import { Link } from "react-router-dom";
import { type ReactNode } from "react";
import { Brand } from "@/components/layout/Brand";
import { Card } from "@/components/ui/card";
import { Container } from "@/components/layout/Container";

type Props = {
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
};

export function AuthCard({ title, description, children, footer }: Props) {
  return (
    <Container size="sm" className="py-12 lg:py-16">
      <div className="mx-auto max-w-md">
        <Link to="/" className="inline-block mb-6">
          <Brand />
        </Link>
        <Card className="p-6 sm:p-8">
          <h1 className="font-display text-2xl font-semibold tracking-tight">{title}</h1>
          {description ? (
            <p className="mt-1.5 text-sm text-text-muted">{description}</p>
          ) : null}
          <div className="mt-6">{children}</div>
        </Card>
        {footer ? <div className="mt-5 text-center text-sm text-text-muted">{footer}</div> : null}
      </div>
    </Container>
  );
}
